<div class="container-fluid">
  <ss-lib-page-layout>
    <div class="container_error">
      <div class="icon_error">
         <svg viewBox="0 0 8 14" fill="#ba3d21" focusable="false" aria-hidden="true">
          <use xlink:href="#error-small"></use>
        </svg>
      </div>
      <p></p>
      @switch (reason) {
        @case ('poid-missing') {
          <h1 class="h1_error" [innerHtml]="poidErrorHeading"></h1>
          <p class="c11n-text-md mt-3 mb-4" [innerHtml]="poidErrorMessage"></p>
        }
        @default {
          <h1 class="h1_error" [innerHtml]="accessDenied"></h1>
          <p class="c11n-text-md mt-3 mb-4" [innerHtml]="accessDenialStatement"></p>
          <a c11n-link href="https://vanguardim.atlassian.net/wiki/x/hyLAJg" target="_blank" variant="primary-reinforced"
            [attr.aria-label]="'https://vanguardim.atlassian.net/wiki/x/hyLAJg'" [fontWeight]="'bold'" class="c11n-link__text"
            title="Access to Internal Statements">
            {{accessInternal}}
          </a>
        }
      }
    </div>
  </ss-lib-page-layout>
</div>
